import getApi from '@web/helpers/api'

import {
    CouponManagingPageSet,
    FetchUseAllCouponRequest,
    FetchUseAllCouponResponse,
    UpdateUseAllCouponRequest,
} from './interfaces'

const api = getApi('/orderApi')

const couponApiUrl: Record<CouponManagingPageSet, Record<'base', string>> = {
    SHOPPING_SUBSCRIPTION: {
        base: '/orderSheet/couponManagement/subscription',
    },
} as const

const fetchUseAllCoupon = async ({pageSet, subscriptionId}: FetchUseAllCouponRequest) => {
    const {
        data: {result},
    } = await api.get<{result: FetchUseAllCouponResponse}>(couponApiUrl[pageSet].base, {params: {subscriptionId}})

    return result
}

const updateUseAllCoupon = async ({pageSet, subscriptionId, useAllCoupon}: UpdateUseAllCouponRequest) => {
    await api.post<{result: FetchUseAllCouponResponse}>(couponApiUrl[pageSet].base, {subscriptionId, useAllCoupon})
}

export default {fetchUseAllCoupon, updateUseAllCoupon}
